import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const violationDetailConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default violationDetailConfig;
